import React from "react";
import "./Landing.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const Landing = () => {
  return (
    <div className="landing-container">
      {/* <div className="hl-0"></div>
        <div className="hl-1"></div>
        <div className="hl-2"></div>
        <div className="hl-3"></div> */}
      <div className="about-company" style={{ color: "#000", width: "230px" }}>
        Chawla
        <br /> Structural <br /> Design <br /> Engineers <br /> & <br />{" "}
        Consultant
      </div>
      <div className="about-place">
        <div className="heading">HAVELLS INDUSTRIAL SHED At BADDI (H.P.)</div>
        <div className="para" style={{'textAlign': 'justify'}}>
          We designed the complete industrial shed for Havells and it is located
          in Baddi. It is done with specially designed Tubular trusses keeping
          in mind the aesthetic design as demanded by the client. It has got a
          10m span uniquely designed cantilever roof for the porch to cater for
          parking of trailers.
        </div>
        <button className="click-more">
          <Link
            to={"/projects"}
            style={{ textDecoration: "none", color: "#fff" }}
          >
            LOOK MORE
          </Link>
        </button>
      </div>
      {/* <div className="toggle-buttons">
        <div className="prev">
          <FontAwesomeIcon icon="fa-thin fa-arrow-right" /> PREV
        </div>
        <div className="next">
          NEXT <FontAwesomeIcon icon="fa-thin fa-arrow-left" />
        </div>
      </div> */}
    </div>
  );
};

export default Landing;
